'use strict';


'kiwi public';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _state = require('@/libs/state');

var _state2 = _interopRequireDefault(_state);

var _ContainerHeader = require('./ContainerHeader');

var _ContainerHeader2 = _interopRequireDefault(_ContainerHeader);

var _Sidebar = require('./Sidebar');

var _Sidebar2 = _interopRequireDefault(_Sidebar);

var _NotConnected = require('./NotConnected');

var _NotConnected2 = _interopRequireDefault(_NotConnected);

var _MessageList = require('./MessageList');

var _MessageList2 = _interopRequireDefault(_MessageList);

var _ServerView = require('./ServerView');

var _ServerView2 = _interopRequireDefault(_ServerView);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    components: {
        ContainerHeader: _ContainerHeader2.default,
        Sidebar: _Sidebar2.default,
        NotConnected: _NotConnected2.default,
        MessageList: _MessageList2.default,
        ServerView: _ServerView2.default
    },
    props: ['network', 'buffer', 'sidebarState'],
    data: function data() {
        return {};
    },
    computed: {
        bufferType: function bufferType() {
            var type = '';

            if (!this.buffer) {
                type = 'none';
            } else if (this.buffer.isServer()) {
                type = 'server';
            } else if (this.buffer.isChannel()) {
                type = 'channel';
            } else if (this.buffer.isQuery()) {
                type = 'query';
            }
            return type;
        },
        unreadMessages: function unreadMessages() {
            var count = 0;
            var highlight = false;
            _state2.default.networks.forEach(function (network) {
                network.buffers.forEach(function (buffer) {
                    count += buffer.flags.unread || 0;
                    if (buffer.flags.highlight) {
                        highlight = true;
                    }
                });
            });
            return { count: count, highlight: highlight };
        }
    },
    created: function created() {
        var _this = this;

        this.listen(_state2.default, 'sidebar.toggle', function () {
            _state2.default.$emit('sidebar.' + (_this.sidebarState.isDrawn ? 'hide' : 'show'));
        });
        this.listen(_state2.default, 'sidebar.show', function () {
            _this.sidebarState.showNicklist();
        });
        this.listen(_state2.default, 'sidebar.hide', function () {
            _this.sidebarState.close();
        });
        this.listen(_state2.default, 'userbox.show', function (user, opts) {
            _this.sidebarState.showUser(user);
        });
        this.listen(_state2.default, 'userbox.hide', function () {
            _this.sidebarState.close();
        });
        this.listen(_state2.default, 'document.keydown', function (ev) {
            if (ev.keyCode !== 33 && ev.keyCode !== 34) {
                return;
            }

            var messageList = _this.$el.querySelector('.kiwi-messagelist') || _this.$el.querySelector('.u-tabbed-content');

            if (!messageList) {
                return;
            }

            var scrollDistance = messageList.clientHeight - 0.1 * messageList.clientHeight;
            var scrollTop = messageList.scrollTop;
            var scrollMax = messageList.scrollHeight;

            if (ev.keyCode === 33) {
                scrollTop -= scrollDistance;
                if (scrollTop < 0) {
                    scrollTop = 0;
                }
            } else {
                scrollTop += scrollDistance;
                if (scrollTop > scrollMax) {
                    scrollTop = scrollMax;
                }
            }

            messageList.scrollTop = scrollTop;
        });
    },
    methods: {
        toggleStateBrowser: function toggleStateBrowser() {
            _state2.default.$emit('statebrowser.toggle');
        },
        toggleSidebar: function toggleSidebar() {
            if (this.buffer.isChannel()) {
                _state2.default.$emit('sidebar.toggle');
            }
        }
    }
};
window._kiwi_exports = window._kiwi_exports || {};
if(!window._kiwi_exports["components"]) window._kiwi_exports["components"] = {};
window._kiwi_exports["components"]["Container"]
window._kiwi_exports.components.Container = exports.default ? exports.default : exports;



//////////////////
// WEBPACK FOOTER
// ./build/exports-loader.js!./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/Container.vue
// module id = cX0g
// module chunks = 1